import { config } from "@/messenger/config";
import { TAuthCredentials, TUserSession } from "@/messenger/types/auth.types";
import jwt_decode from "jwt-decode";



export const getChatToken = (credentials: TAuthCredentials) => {
    const { token, customer: customerName, email } = credentials;
    
    const request = new Request(`https://api-ui.messagingkit.com/messenger/start`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ customerName, email }),
    });

    return fetch(request)
        .then((response): Promise<TUserSession> => { 
            return response.json() 
        })
        .then(data => data);
};

export const getDynamicTermsAndConditionsTemplate = (): Promise<any> =>
    fetch("https://uuid.hasura.app/api/rest/us.textkit.io/terms")
        .then(response => response.json())
        .catch(err => console.log(err));

export const getAllTopics = (): Promise<any> => {
    const request = new Request(`${config.api.messenger.graphqlTouchless()}/graphql`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${window.Touchless.token}`,
        },
        body: JSON.stringify({
            query: `
                query FindAllTopics {
                    topics: touchless_topic(where: {state: {_eq: "ACTIVATED"}}) {
                        topic_id: uuid
                        id: uuid
                        description: context_text
                        name: context_text
                        state
                    }
                }
            `
        })
    })

    return fetch(request)
        .then((response): Promise<any> => response.json())
        .then(data => data);
}

export const getTeamConversations = (user, category, outbound): Promise<any> => {
    
    const decoded = jwt_decode(window.Touchless.token);
    const customerId = decoded['https://textkit.io'].customerId;
    console.log(category)
    console.log(user)
    const request = new Request(`${config.api.touchless}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${window.Touchless.token}`,
        },
        body: JSON.stringify({
            query: `query FindTeamConversations ($category: String, $outbound: String, $customerId: prod_us_uuid) @cached (ttl: 3) {
                  conversations: api_ui_aggregated_conversation(where: {category: {category: {_eq: $category}, customer_id: {_eq: $customerId} }, outbound_address: {_like: $outbound}}, order_by: {category: {last_message_received_at: desc}})  {
                    channel
                    id: conversation_id
                    category {
                        name:category
                    }
                    contact_id
                    contact_first_name
                    contact_last_name
                    outbound_address
                    representative_id
                    representative_user_id
                    messages(limit: 1, order_by: {sent_at: desc}) {
                      body
                      timestamp: sent_at
                    }
                  }
              }`,
              variables : {
                customerId: customerId,
                category: category,
                outbound: outbound ? outbound : '%'
              }

        })
    })
    

    return fetch(request)
    .then((response): Promise<any> => response.json())
    .then(data => data);

}

export const getOutboundNumbers = (): Promise<any> => {
    
  const request = new Request(`${config.api.messenger.graphqlTouchless()}/graphql`, {
      method: "POST",
      headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${window.Touchless.token}`,
      },
      body: JSON.stringify({
          query: `query getNumbers {
              phone_numbers: touchless_phone_number {
                outbound_address
              }
            }
                  
            `,

      }),
  });


return fetch(request)
.then((response): Promise<any> => response.json())
.then(data => data);

};


export const getAllSpaces = (): Promise<any> => {
    
    const request = new Request(`${config.api.touchless}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${window.Touchless.token}`,
        },
        body: JSON.stringify({
            query: `
            query getAllSpaces {
                prod_us {
                  spaces: representative(order_by: {customer_id: asc}, distinct_on: customer_id) {
                    customer_id
                  }
                }
                prod_ca {
                  spaces: representative(order_by: {customer_id: asc}, distinct_on: customer_id) {
                    customer_id
                  }
                }
              }
            `
        })
    })

    return fetch(request)
        .then((response): Promise<TUserSession> => response.json())
        .then(data => data);

}
        
export const getPhoneType = (phoneNumber: string): Promise<any> =>
    fetch(`https://api-ui.messagingkit.com/lookup/${phoneNumber}`)
        .then(response => response.json())
        .catch(err => console.log(err));

export const getTermsAndConditionsTemplate = (): Promise<any> =>
    fetch("https://terms-and-conditions-template.s3.amazonaws.com/termsAndConditionsTemplate.html")
        .then(response => response.text())
        .catch(err => console.log(err));

export const getBranches = (host: string): Promise<any> =>
    fetch(`https://api-touchless.textkit.statflo.com/api/rest/project/${host}/selectable/context`)
        .then(response => response.json())
        .catch(err => console.log(err));

export const getExoContext = (type: string, key: string, relationship: string, path: string): Promise<any> =>
    fetch(`https://api-touchless.textkit.statflo.com/api/rest/${type}/${key}/${relationship}/${path}`)
        .then(response => response.json())
        .catch(err => console.log(err));

